import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	LikeSupporterCommentSunriseMutation,
	LikeSupporterCommentSunriseMutationVariables,
} from './likeComment.graphql';
import { LikeSupporterCommentSunrise } from './likeComment.graphql';

export type LikeCommentInput = LikeSupporterCommentSunriseMutationVariables['input'];
export type LikeCommentResponse = Pick<LikeSupporterCommentSunriseMutation['likeComment'], 'success' | 'liked'>;

export async function likeComment(
	{ gql: { fetch } }: UtilityContext,
	{ commentId, like }: LikeCommentInput,
): Promise<LikeCommentResponse> {
	const { data } = await fetch<LikeSupporterCommentSunriseMutation, LikeSupporterCommentSunriseMutationVariables>({
		query: LikeSupporterCommentSunrise,
		variables: {
			input: {
				commentId,
				like,
			},
		},
		rejectOnError: true,
	});

	if (!data.likeComment.success) throw new Error(`Unable to like comment (${data.likeComment.reason || 'unknown'})`);

	return data.likeComment;
}
